import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { button, type ButtonVariants } from '../recipes/button';

type ButtonProps = ButtonVariants &
  ComponentProps<'button'> & {
    /** Disables the button and marks it busy for assistive tech. */
    busy?: boolean;
  };

/**
 * Sets `type='button'`, because a bare <button> inside a form submits it, and
 * disables while busy so a double click fires once. For a link that looks like
 * a button, apply the `button` recipe to the link.
 */
export const Button = ({
  intent,
  size,
  float,
  block,
  tone,
  busy,
  className,
  children,
  disabled,
  ...props
}: ButtonProps) => (
  <button
    type='button'
    disabled={disabled === true || busy === true}
    aria-busy={busy === true ? true : undefined}
    className={cn(button({ intent, size, float, block, tone }), className)}
    {...props}>
    {children}
  </button>
);
